import { FolderEntity } from "@/app/entities/FolderEntity"
import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"

interface FolderState {
  folders: FolderEntity[]
  selectedFolders: string[]

  hasFoldering: (id: string) => boolean
  setFolderData: (res: FolderEntity[]) => void
  clearFolderData: () => void
  addFolder: (folder: FolderEntity) => void
  updateFolder: (id: string, name: string, isPublic: boolean) => void
  clearSelectedFolders: () => void
  addSelectedFolder: (folderId: string | string[]) => void
  isSelected: (folderId: string) => boolean
}

export const useSelectedFolderStore = create<FolderState>()(
  persist(
    (set, get) => ({
      folders: [],
      selectedFolders: [],
      hasFoldering: (id: string) => {
        const { folders } = get()
        const check = folders.some((item) => {
          return item.id === id
        })
        return check
      },
      setFolderData: (res) =>
        set(() => ({
          folders: res,
        })),
      clearFolderData: () => {
        set(() => ({ folders: [] }))
      },
      addFolder: (folder) =>
        set((state) => {
          const items = [...state.folders]
          if (items.length === 0 || items[0].folderType !== "SYSTEM_DEFAULT") {
            console.warn(
              "[useUserStore] Invariant violation: first item should be type BASIC.",
            )
          }
          const tail =
            items.length > 0 &&
            items[items.length - 1].folderType === "SYSTEM_MIGRATION"
              ? items.pop()
              : undefined
          items.splice(1, 0, folder)
          if (tail) items.push(tail)
          return { folders: items }
        }),
      updateFolder: (id, name, isPublic) =>
        set((state) => ({
          folders: state.folders.map((item) =>
            item.id === id
              ? {
                  ...item,
                  name,
                  isPublic,
                  updatedAt: new Date().toISOString(),
                }
              : item,
          ),
        })),
      clearSelectedFolders: () =>
        set(() => ({
          selectedFolders: [],
        })),
      addSelectedFolder: (folderId) =>
        set((state) => {
          if (Array.isArray(folderId)) {
            return {
              selectedFolders: [
                ...state.selectedFolders.filter((id) => !folderId.includes(id)),
                ...folderId,
              ],
            }
          } else {
            return {
              selectedFolders: state.selectedFolders.includes(folderId)
                ? state.selectedFolders.filter((id) => id !== folderId)
                : [...state.selectedFolders, folderId],
            }
          }
        }),
      isSelected: (folderId) => {
        const { selectedFolders } = get()
        return selectedFolders.includes(folderId)
      },
    }),
    {
      name: "my-folder-store",
      partialize: (state) => ({
        folders: state.folders,
        selectedFolders: state.selectedFolders,
      }),
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
